// extracted by mini-css-extract-plugin
module.exports = {"embedInline":"NewsEmbedInline_embedInline__yXWBy","tooltip":"NewsEmbedInline_tooltip__Be36j"};